module.exports = __webpack_public_path__ + "static/media/rightArrow.f470283e.svg";